import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    flexShrink: 0,
  },
  iconButton: {
    color: theme.palette.text.secondary,
    svg: {
      color: theme.palette.text.secondary,
    },
  },
  unreadDot: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    pointerEvents: 'none',
    zIndex: 1,
  },
}));
